import { useTranslation, Trans } from "react-i18next";

import tr from '../../img/TradingTools/gr.png'

function Explore() {

  const { t } = useTranslation();

  return (
    <div className="relative pt-[80px] xl:pt-[160px] overflow-hidden">
        <div className="max-w-[1220px] mx-[20px] xl:mx-auto flex flex-col">
            <div className="flex flex-col xl:flex-row justify-between">
                <div className="flex flex-col items-start">
                    <p className="zen-dots leading-[1.2] text-[24px] xl:text-[36px] text-[#1E1C21] xl:max-w-[497px]">
                        <Trans>{t("trading.29")}</Trans>
                    </p>
                    <p className="xl:max-w-[497px] text-[#000000B2] text-[14px] ibm-plex mt-[20px]">
                        {t("trading.30")}
                    </p>
                    <p className="zen-dots leading-[1.2] text-[16px] xl:text-[20px] text-[#1E1C21] xl:max-w-[497px] mt-[20px] xl:mt-[40px]">
                        <Trans>{t("trading.31")}</Trans>
                    </p>
                    <div className="grid grid-cols-1 xl:grid-cols-2 mt-[20px] xl:mt-[30px] gap-[12px] xl:gap-[20px]">
                        <div className="flex items-center gap-[10px]">
                            <div className="w-[4px] h-[4px] bg-[#1E1C21] flex-shrink-0"></div>
                            <p className="ibm-plex font-[500] leading-[1.2] text-[#1F1F1F] text-[14px] xl:text-[16px]">{t("trading.32")}</p>
                        </div>
                        <div className="flex items-center gap-[10px]">
                            <div className="w-[4px] h-[4px] bg-[#1E1C21] flex-shrink-0"></div>
                            <p className="ibm-plex font-[500] leading-[1.2] text-[#1F1F1F] text-[14px] xl:text-[16px]">{t("trading.33")}</p>
                        </div>
                        <div className="flex items-center gap-[10px]">
                            <div className="w-[4px] h-[4px] bg-[#1E1C21] flex-shrink-0"></div>
                            <p className="ibm-plex font-[500] leading-[1.2] text-[#1F1F1F] text-[14px] xl:text-[16px]">{t("trading.34")}</p>
                        </div>
                        <div className="flex items-center gap-[10px]">
                            <div className="w-[4px] h-[4px] bg-[#1E1C21] flex-shrink-0"></div>
                            <p className="ibm-plex font-[500] leading-[1.2] text-[#1F1F1F] text-[14px] xl:text-[16px]">{t("trading.35")}</p>
                        </div>
                    </div>
                </div>
                <img src={tr} alt="" className="mt-[40px] xl:mt-0"/>
            </div>
        </div>
    </div>
  );
}

export default Explore;
